import React from "react";
import { Assort } from "../../models/Assort";
import { Box, Button, createStyles, darken, Grid, Theme, Typography } from "@material-ui/core";
import styled from "styled-components";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { blue } from "@material-ui/core/colors";

interface IProps {
  ticket: Assort;
  onBtnClick: (ticket: Assort) => void;
}

const TicketButton = styled(Button)`
  display: inline;
  width: 100%;
  border: "1px solid #fff";
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    primary: {
      backgroundColor: blue[600],
      color: theme.palette.getContrastText(blue[600]),
      "&:hover": {
        backgroundColor: darken(blue[600], 0.1),
      },
    },
    select: {
      backgroundColor: blue[300],
      color: theme.palette.getContrastText(blue[300]),
      "&:hover": {
        backgroundColor: darken(blue[300], 0.1),
      },
    },
  })
);

const TicketButtonSet: React.FC<IProps> = ({ ticket, onBtnClick }: IProps) => {
  const classes = useStyles();

  return (
    <TicketButton variant={"contained"} className={classes.primary} onClick={() => onBtnClick(ticket)}>
      <Grid container alignItems={"center"}>
        <Grid item xs={6}>
          <Typography variant={"button"} display={"block"}>
            {ticket.name}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.select}>
          <Typography variant={"caption"} display={"block"} style={{ margin: 0 }}>
            Dodaj do koszyka
          </Typography>
          <Typography variant={"caption"} display={"block"} style={{ margin: 0 }}>
            {`${ticket.listPrice} zł`}
          </Typography>
        </Grid>
      </Grid>
    </TicketButton>
  );
};

export default TicketButtonSet;
